import React from 'react'

// mui
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

// local components
import Form from './Form'
import MinAgeEligibility from 'components/shared/MinAgeEligibility'
import MaxAgeEligibility from 'components/shared/MaxAgeEligibility'

const PanelContents = props => {
  const { camper, session, camperSession, cartForm } = props

  const { showAgeWarning, tooOld, tooYoung } = camperSession

  if (tooYoung) {
    return (
      <MinAgeEligibility>
        <Typography paragraph fontWeight='fontWeightBold'>
          Unfortunately it looks like your camper is still too young for camp.
        </Typography>
      </MinAgeEligibility>
    )
  }

  if (tooOld) {
    return (
      <MaxAgeEligibility>
        <Typography paragraph fontWeight='fontWeightBold'>
          Unfortunately it looks like your camper is too old for camp.
        </Typography>
      </MaxAgeEligibility>
    )
  }

  const cartProducts = cartForm.cartProducts.filter(
    cp => cp.session.id === session.id && cp.camper.id === camper.id
  )

  const cartProductKey = cartProduct =>
    cartProduct.product ? cartProduct.product.id : null

  return (
    <>
      {showAgeWarning && (
        <Box mb={4}>
          <MinAgeEligibility />
        </Box>
      )}
      {cartProducts.map((cartProduct, index) => (
        <Form
          key={cartProductKey(cartProduct)}
          cartProduct={cartProduct}
          divider={index < cartProducts.length - 1}
          {...props}
        />
      ))}
    </>
  )
}

export default PanelContents
